<template>
	<div :class="'switch' + (_active ? ' active' : '')" @click="onChange">
		<div class="switch__switch"></div>
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: [Boolean, Array]
			},
			name: {
				tyoe: String,
				default: null
			}
		},
		computed: {
			_active() {
				return Array.isArray(this.value) ? this.value.includes(this.name) : this.value;
			}
		},
		methods: {
			onChange() {
				if (Array.isArray(this.value)) {
					var items = Array.from(this.value);
					
					if (this._active) {
						const index = items.indexOf(this.name);
						if (index > -1) items.splice(index, 1);
					} else {
						items.push(this.name);
					}

					this.$emit('input', items)
				} else {
					this.$emit('input', !this.value);
				}
			}
		}
	}
</script>

<style lang="scss">
	.switch {
		width: 40px;
		height: 20px;
		border-radius: 10px;
		background-color: #3b3d44;
		position: relative;
		cursor: pointer;

		&__switch {
			position: absolute;
			left: 2px;
			top: 2px;
			width: 16px;
			height: 16px;
			background-color: black;
			border-radius: 50%;
		}

		&.light {
			background-color: white;
		}

		&.light &__switch {
			background-color: rgb(172, 172, 172);
		}
	}

	.switch.active {
		background-color: #f7223f;

		& > .switch__switch {
			left: auto;
			right: 2px;
		}

		&.light .switch__switch {
			background-color: white;
		}
	}
</style>